import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/Button';
interface NavbarProps {
  minimal?: boolean;
}
export function Navbar({
  minimal = false
}: NavbarProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);
  const navClasses = `fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled || minimal ? 'bg-white shadow-sm py-3' : 'bg-transparent py-5'}`;
  const logoClasses = `font-serif font-bold tracking-wider ${isScrolled || minimal ? 'text-forest text-xl' : 'text-cream text-2xl'}`;
  const linkClasses = `text-sm font-medium transition-colors ${isScrolled ? 'text-charcoal hover:text-gold' : 'text-cream hover:text-gold'}`;
  if (minimal) {
    return <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm h-[60px] flex items-center px-6" data-id="element-168">
        <div className="max-w-7xl mx-auto w-full flex justify-center md:justify-start" data-id="element-169">
          <Link to="/" className="font-serif font-bold text-forest text-xl tracking-wider" data-id="element-170">
            CRESTWOOD HOMES
          </Link>
        </div>
      </nav>;
  }
  return <nav className={navClasses} data-id="element-171">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-172">
        <div className="flex justify-between items-center" data-id="element-173">
          <Link to="/" className={logoClasses} data-id="element-174">
            CRESTWOOD HOMES
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-175">
            <a href="#communities" className={linkClasses} data-id="element-176">
              Communities
            </a>
            <a href="#floor-plans" className={linkClasses} data-id="element-177">
              Floor Plans
            </a>
            <a href="#about" className={linkClasses} data-id="element-178">
              About
            </a>
            <a href="#contact" className={linkClasses} data-id="element-179">
              Contact
            </a>
            <Button to="/experience" variant={isScrolled ? 'primary' : 'primary'} size="sm" data-id="element-180">
              Design Your Home
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center" data-id="element-181">
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className={isScrolled ? 'text-forest' : 'text-cream'} aria-label="Toggle menu" data-id="element-182">
              {mobileMenuOpen ? <X size={24} data-id="element-183" /> : <Menu size={24} data-id="element-184" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav */}
      {mobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-white shadow-lg border-t border-gray-100" data-id="element-185">
          <div className="px-4 pt-2 pb-6 space-y-1 flex flex-col" data-id="element-186">
            <a href="#communities" className="block px-3 py-3 text-base font-medium text-charcoal hover:bg-cream" data-id="element-187">
              Communities
            </a>
            <a href="#floor-plans" className="block px-3 py-3 text-base font-medium text-charcoal hover:bg-cream" data-id="element-188">
              Floor Plans
            </a>
            <a href="#about" className="block px-3 py-3 text-base font-medium text-charcoal hover:bg-cream" data-id="element-189">
              About
            </a>
            <a href="#contact" className="block px-3 py-3 text-base font-medium text-charcoal hover:bg-cream" data-id="element-190">
              Contact
            </a>
            <div className="pt-4 px-3" data-id="element-191">
              <Button to="/experience" fullWidth data-id="element-192">
                Design Your Home
              </Button>
            </div>
          </div>
        </div>}
    </nav>;
}